// import { toast } from "react-toastify";
import { Table } from "react-bootstrap";
import RequestModal from "./RequestModal";
import { Formik, Form, Field } from "formik";
import React, { useEffect, useState } from "react";
import InfluencerConfirm from "./InfluencerConfirm";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Contexts/auth.context";
import * as Yup from "yup";
import {
  addInfluencerFee,
  getTierInfo,
  updateInfluencerFee,
  updateInfluencerProfile,
  user_profile,
} from "../../../Services/prod/auth.service";
import { formatCommaNumbers } from "../../../Utils/common.utils";
import Loading from "../../../components/loading/loading.component";

const Step2 = ({ feeData, stepOneData, profileData, setUpdate }) => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [loading, setloading] = useState(false);
  const [description, setDescription] = useState("");
  const [influencerName, serInfluencerName] = useState("");
  const [showConfirm, setShowConfirm] = useState({ show: false, data: "" });
  const [tierInfo, setTierInfo] = useState({
    tier1_min: 0,
    tier1_max: 0,
    tier2_min: 0,
    tier2_max: 0,
    tier3_min: 0,
    tier3_max: 0,
  });

  // Dynamic Influencer Name By Using Mprofile API
  useEffect(() => {
    if (auth) {
      user_profile(auth?.userId).then((data) => {
        if (data) {
          serInfluencerName(
            data[0]?.user_firstname + " " + data[0]?.user_lastname
          );
        }
      });
    }
  }, []);
  const actiondata = [
    {
      tier: "1",
      listeners: `${formatCommaNumbers(
        tierInfo?.tier1_min
      )} to ${formatCommaNumbers(tierInfo?.tier1_max)}`,
      commission:
        feeData?.influencer_fee === null
          ? feeData?.global_tier_fee?.first_tier_fee
          : feeData?.influencer_fee?.first_tier_fee || "",
      placeholder: "3.0",
    },
    {
      tier: "2",
      listeners: `${formatCommaNumbers(
        tierInfo?.tier2_min
      )} to ${formatCommaNumbers(tierInfo?.tier2_max)}`,
      commission:
        feeData?.influencer_fee === null
          ? feeData?.global_tier_fee?.second_tier_fee
          : feeData?.influencer_fee?.second_tier_fee || "",
      placeholder: "5.0",
    },
    {
      tier: "3",
      listeners: `${formatCommaNumbers(
        tierInfo?.tier3_min
      )} to ${formatCommaNumbers(tierInfo?.tier3_max)}`,
      commission:
        feeData?.influencer_fee === null
          ? feeData?.global_tier_fee?.third_tier_fee
          : feeData?.influencer_fee?.third_tier_fee || "",
      placeholder: "7.0",
    },
  ];

  // Validation schema
  const validationSchema = Yup.object().shape({
    commissions: Yup.array().of(
      Yup.number()
        .required("Commission is required")
        .min(1, "Commission must be 1")
        .max(100, "Commission should be upto 100")
        .typeError("Must be Number")
    ),
    specialCommission: Yup.number()
      .required("Secondary Commission is required")
      .min(1, "Secondary Commission must be 1")
      .max(100, "Secondary Commission should be upto 100")
      .typeError("Must be Number"),
  });

  const influencerStatus = localStorage.getItem("isInfluencerProfile");
  const handleFees = async (values) => {
    try {
      if (values) {
        setloading(true);
        // FEES PAYLOAD
        const feePayload = {
          first_tier_fee: values?.commissions[0],
          second_tier_fee: values?.commissions[1],
          third_tier_fee: values?.commissions[2],
          description: description || feeData?.influencer_fee?.description,
        };
        let feeResponse = null;
        if (influencerStatus === "null") {
          // ADD INFLUENCER FEES
          feeResponse = await addInfluencerFee(feePayload);
        } else {
          if (feeData?.influencer_fee?.id) {
          // UPDATE INFLUENCER FEES
            feeResponse = await updateInfluencerFee({
              ...feePayload,
              id: feeData?.influencer_fee?.id,
            });
          } else {
          // ADD INFLUENCER FEES { When influencer_fee object is "null" }
            feeResponse = await addInfluencerFee(feePayload);
          }
        }

        if (feeResponse) {
          // PROFILE PAYLOAD
          const profilePayload = {
            image: stepOneData?.image || "",
            name: influencerName || profileData?.influencer_meta?.name,
            description: stepOneData?.description,
            youtube_channel_name: stepOneData?.youtubeChannelName || "",
            youtube_monthly_views: stepOneData?.youtubeViews || 0,
            instagram_channel_name: stepOneData?.instagramChannelName || "",
            instagram_followers: stepOneData?.instagramViews || 0,
            facebook_channel_name: stepOneData?.facebookChannelName || "",
            facebook_followers: stepOneData?.facebookViews || 0,
            twitter_channel_name: stepOneData?.twitterChannelName || "",
            twitter_followers: stepOneData?.twitterViews || 0,
            tiktok_channel_name: stepOneData?.tiktokChannelName || "",
            tiktok_followers: stepOneData?.tiktokViews || 0,
            re_apply_comment: stepOneData?.re_apply_comment || "",
          };

          // UPDATE INFLUENCER PROFILE
          const profileRes = await updateInfluencerProfile(profilePayload);
          if (profileRes?.status === 200 || profileRes?.status === 201) {
            setShowConfirm({
              show: true,
              data:
                influencerStatus === "null"
                  ? "Profile Added Successfully, Your Profile is being reviewed by MusicBull. Once approved, you will be enrolled in our program."
                  : "Profile Updated Successfully!",
            });
            localStorage.setItem("isInfluencerProfile", "PENDING");
          }
        }
      }
      setUpdate(true);
    } catch (error) {
      console.log(error, "error");
      setloading(false);
      setShowConfirm({
        show: false,
        data: "Something went wrong",
      });
    } finally {
      setloading(false);
      setUpdate(true);
    }
  };

  // ==================== VALIDATION OF TIER INPUTS ====================
  const handleNumberInput = (e) => {
    const invalidKeys = ["-", "+", "e", " "];
    if (invalidKeys.includes(e.key) || e.keyCode === 32) {
      e.preventDefault();
    }
  };

  const handleNumberChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9.]/g, "");
    const cursorPosition = e.target.selectionStart; 
    const decimalIndex = value.indexOf(".");
    if (decimalIndex !== -1) {
      value = value.slice(0, decimalIndex + 3); 
    }
    e.target.value = value;
    e.target.setSelectionRange(cursorPosition, cursorPosition);
  };

  // ==================== TIER INFO API ====================
  useEffect(() => {
    const tierInfo = async () => {
      const createFeesRes = await getTierInfo();
      setTierInfo(createFeesRes[0]);
    };
    tierInfo();
  }, []);
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Formik
          initialValues={{
            commissions: actiondata.map((item) => {
              const commissionValue = item.commission
                ? parseFloat(item.commission)
                : "";
              return isNaN(commissionValue) ? 0 : commissionValue;
            }),
            specialCommission:
              feeData?.influencer_fee === null
                ? feeData?.global_tier_fee?.secondary_market_fee
                : feeData?.influencer_fee?.secondary_market_fee || "",
            description: feeData?.influencer_fee?.description || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleFees(values);
          }}
        >
          {({ errors, touched, values }) => (
            <Form>
              <div className="auction">
                <h3>Auction Commissions</h3>
                <p>
                  Specify the commission rates you want to charge issuers for
                  successfully promoting their auction.
                </p>
                <p>
                  We offer a three-tier promotion program based on the
                  popularity of the issued rights.
                </p>
                <p>
                  Your proposed rates will be visible to the issuer, who has
                  full discretion to invite you directly.{" "}
                  <strong>Keep in mind</strong>, payment is based on auction's
                  success, ensuring a fair deal for both parties
                </p>
                <div className="auction_table">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Tier</th>
                        <th>Monthly Listeners</th>
                        <th>Commission</th>
                      </tr>
                    </thead>
                    <tbody>
                      {actiondata?.map((item, index) => (
                        <tr key={index}>
                          <td>Tier {item.tier}</td>
                          <td>{item.listeners}</td>
                          <td>
                            <Field
                              name={`commissions[${index}]`}
                              className="commission_box"
                              placeholder={item?.placeholder}
                              type="text"
                              onInput={handleNumberChange}
                              onKeyDown={handleNumberInput}
                            />
                            %{" "}
                            {errors.commissions &&
                              errors.commissions[index] &&
                              touched.commissions &&
                              touched.commissions[index] && (
                                <div className="error error_space">
                                  {errors.commissions[index]}
                                </div>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
              <hr className="custom_hr" />
              <div className="market">
                <h3>Secondary Market Commissions</h3>
                <p>
                  Our commissions are based on successful transactions made
                  within a 6-month period after your referred users to register
                  on the MusicBull platform. Our standard commission rate is 1%.
                  If you believe you can bring unique value, you may submit a
                  different commission rate for consideration, and we will
                  review your request.
                </p>
                <div className="auction_table">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Commission</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Field
                            name="specialCommission"
                            className="commission_box"
                            placeholder="1.0"
                            type="number"
                            onInput={handleNumberChange}
                            onKeyDown={handleNumberInput}
                            // disabled={influencerStatus !== "null"}
                            disabled={true}
                          />
                          %
                          {errors.specialCommission &&
                            touched.specialCommission && (
                              <div className="error error_space">
                                {errors.specialCommission}
                              </div>
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <Link
                    to="#"
                    className={`submit_link ${influencerStatus!=="null"&& "disabled"}`}
                    onClick={() => setShow(true)}
                  >
                    Submit a special request
                  </Link>
                </div>
              </div>
              <button
                type="submit"
                className="submit_btn"
                // disabled={profileData?.influencer_request === "PENDING"}
              >
                Submit
              </button>
              {/* {profileData?.influencer_request === "PENDING" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    borderRadius: "5px",
                    color: "#856404",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  <span style={{ marginRight: "8px", fontSize: "20px" }}>
                    ⏳
                  </span>
                  <span>Request is currently under review.</span>
                </div>
              )} */}
              <h5>
                Registering as an Influencer does not guarantee enrollment and
                needs to be approved by MusicBull
              </h5>
              <RequestModal
                show={show}
                handleClose={() => setShow(false)}
                values={values}
                description={description}
                setDescription={setDescription}
              />{" "}
            </Form>
          )}
        </Formik>
      )}
      {showConfirm?.show && (
        <InfluencerConfirm
          show={showConfirm?.show}
          handleClose={() => {
            setShowConfirm(false);
            navigate("/influncer-profile");
          }}
          description={showConfirm?.data}
        />
      )}
    </>
  );
};

export default Step2;
